
    <table class="styled-table w-full">
        <thead>
        <tr class="header">
            <th >RÉFÉRENCE</th>
            <th>DOCUMENT</th>

            <th>PRIX</th>

        </tr>
        </thead>
        <tbody>
        <tr style="height: 50px">
            <td>FAC-001</td>
            <td>FACTURE</td>
            <td>50,000 TND</td>

        </tr>
        </tbody>
    </table>

